/////////////////////////////
// Parametros del sistema //
/////////////////////////////
var appSettings = {
  isDevelopment: true,

  // Desarrollo
  //restApiServiceBaseUri: 'http://localhost:8080/SIGMA_DMZ/webapi/', // REST Api
  
  // sistemaId : 14.1,  //id sistema  oauth

  // // //Pruebas
  //restApiServiceBaseUri: 'http://wsdesacit.oj.gob.gt:8080/SIGMA_DMZ/webapi/', // REST Api
  // sistemaId : 14.1,  //id sistema  oauth

  // //Capacitacion
  // restApiServiceBaseUri: 'http://localhost:8080/SIGMA_DMZ/webapi/', // REST Api
  //sistemaId : 14.1,  //id sistema  oauth

  // //Produccion
   restApiServiceBaseUri: 'http://serviciosrest.oj.gob.gt:8080/SIGMA_DMZ/webapi/', // REST Api
  // sistemaId : 14.1,  //id sistema  oauth

  //Produccion Internet
  // restApiServiceBaseUri: 'http://serviciosrest.oj.gob.gt:8080/SIGMA_DMZ/webapi/', // REST Api
  // sistemaId : 14.1,  //id sistema  oauth


  //appVersion: '3.55',
  //downloadBaseUri: 'http://isgttest:58528', // FILES desarrollo
  // restApiServiceBaseUri: 'http://cidejapp.oj.gob.gt/PrbRestDMZSgtV2/', // REST produccion
  // downloadBaseUri: 'http://cidejapp.oj.gob.gt/PrbArchivosDMZSgtV2', // FILES produccion
  Sistema:'SIGMA',
  timeOuttoastrNotifications: '15000',
  paginationPageSizes: [10, 25, 50],
  paginationMinPageSizes: [5, 10, 25],
  smartTable: { itemsByPage: 5, displayedPages: 5 },
  //constantes:[]
};

/////////////////////////////
// Inicializacion de modulo//
// principal del sistema   //
/////////////////////////////
angular.module( 'app', [
  'templates-app',
  'ngSanitize',
  'ui.bootstrap',
  'ui.grid',
  'ui.grid.pagination',
  'ui.grid.selection',
  'ui.grid.exporter',
  'ui.grid.edit',
  'ui.grid.autoResize',
  'ui.grid.grouping',
  'ui.grid.treeView',
  'ui.router',
  'ui.select',
  //'ui.calendar',
  'mwl.calendar',
  'LocalStorageModule',
  'chieffancypants.loadingBar',
  'toastr',
  'ngDialog',
  'ui.mask',
  'chart.js',
  'base64',
  'ngFileUpload',
  'swipe',
  'angular-carousel-3d',
  'treeControl',
  'ngMagnify',
  'smart-table',
  'duScroll',
  'ui.bootstrap.datetimepicker',
  'ui.bootstrap.tooltip',

  'app.utilsService',
  'app.authInterceptorService',
  'app.directives',
  'mdo-angular-cryptography-oj',

  'app.parametrizacion',
  'app.dashboard',
  'app.facilitadores'

])

.filter( 'dateFilter', ['$filter', function ($filter) {
  return function (input) {
    if (!input) {
      return '';
    } else {
      return $filter( 'date' )(new Date(input),'dd/MM/yyyy' );
    }
  };
}])

.filter( 'propsFilter', [function () {
  return function (items, props) {
    var out = [];

    if (angular.isArray(items)) {
      items.forEach( function (item) {
        var itemMatches = false;

        var keys = Object.keys(props);
        for (var i = 0; i < keys.length; i++) {
          var prop = keys[i];
          var text = props[prop].toLowerCase();
          if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
            itemMatches = true;
            break;
          }
        }

        if (itemMatches) {
          out.push(item);
        }
      });
    } else {
      // Let the output be the input untouched
      out = items;
    }

    return out;
  };
}])

.run(
  [          '$rootScope', '$state', '$stateParams', 'appSettings', 'toastr', 'ngDialog', 
    function ($rootScope,   $state,   $stateParams,   appSettings,   toastr,   ngDialog) {

      // add references to $state and $stateParams to the $rootScope
      // For example <li ng-class="{ active: $state.includes( 'contacts.list' ) }"> will set the <li>
      // to active whenever 'contacts.list' or one of its decendents is active.
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;

      $rootScope.$on( '$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        // prevenir accion por default
        event.preventDefault();
        // cerrar todos los dialogos abiertos si hay
        ngDialog.close();

        if ( error && error.status == 401 ) {
          $state.go( 'index.home' );
        } else {
          location.href = '#/';
        }
      });

    }
  ]
)

.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push( 'authInterceptorService' );
}])

.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
  cfpLoadingBarProvider.spinnerTemplate = '<div class="spinner"> <div id="loading-bar-spinner"><div class="preloader pl-lg"> <svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg> </div></div> </div>';
}])

.config(['ngDialogProvider', function (ngDialogProvider) {
  ngDialogProvider.setDefaults({
    className: 'ngdialog-theme-flat',
    showClose: true,
    closeByDocument: true,
    closeByEscape: true,
    cache: true,
    overlay: true
  });
}])

.config(['$locationProvider', function($locationProvider) {
    $locationProvider.hashPrefix('');
    }])


.config(['toastrConfig', function (toastrConfig) {
  angular.extend(toastrConfig, {
    autoDismiss: false,
    containerId: 'toast-container',
    maxOpened: 0,
    newestOnTop: true,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    target: 'body'
  });
}])

.constant('uiDatetimePickerConfig', {
    dateFormat: 'yyyy-MM-dd HH:mm',
    defaultTime: '00:00:00',
    html5Types: {
        date: 'yyyy-MM-dd',
        'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
        'month': 'yyyy-MM'
    },
    initialPicker: 'date',
    reOpenDefault: false,
    enableDate: true,
    enableTime: true,
    buttonBar: {
        show: true,
        now: {
            show: true,
            text: 'Ahora',
            cls: 'btn-sm btn-default'
        },
        today: {
            show: true,
            text: 'Hoy',
            cls: 'btn-sm btn-default'
        },
        clear: {
            show: true,
            text: 'Limpiar',
            cls: 'btn-sm btn-default'
        },
        date: {
            show: true,
            text: 'Fecha',
            cls: 'btn-sm btn-warning'
        },
        time: {
            show: true,
            text: 'Hora',
            cls: 'btn-sm btn-warning'
        },
        close: {
            show: true,
            text: 'Confirmar',
            cls: 'btn-sm btn-info'
        },
        cancel: {
            show: false,
            text: 'Cancelar',
            cls: 'btn-sm btn-danger'
        }
    },
    closeOnDateSelection: true,
    closeOnTimeNow: true,
    appendToBody: false,
    altInputFormats: [],
    ngModelOptions: {},
    saveAs: false,
    readAs: false
})

/* .config( function (calendarConfig) {
  calendarConfig.showTimesOnWeekView = true; //Make the week view more like the day view, with the caveat that event end times are ignored.
})*/

.config(
  [          '$stateProvider', '$urlRouterProvider',
    function ($stateProvider,   $urlRouterProvider) {

     /* var authenticated = ['$location', '$q', 'authService', function ($location, $q, authService) {
        var deferred = $q.defer();
        if ( authService.isLoggedIn() ) {
          deferred.resolve();
        } else {
          deferred.reject( { status: 401 } );
        }
        return deferred.promise;
      }];*/

      /////////////////////////////
      // Redirects and Otherwise //
      /////////////////////////////

      $urlRouterProvider

        // If the url is ever invalid, e.g. '/asdf', then redirect to '/' aka the home state
        .otherwise( '/' );


      //////////////////////////
      // State Configurations //
      //////////////////////////

      // Use $stateProvider to configure your states.
      $stateProvider

        //////////
        // Home //
        //////////

        .state("index", {
          abstract: true,
          url: "/",
          templateUrl: 'app/index.tpl.html',
          resolve: 
          {
            dataBaseColor: ['dashboardService',function( dashboardService){return dashboardService.getBaseColor()}]
          },
          controller: ['$scope', 'toastr', 'appSettings', 'utilsService', '$state', '$window', 
            'localStorageService','ngDialog', 'dataBaseColor',
            function ($scope, toastr, appSettings, utilsService, $state, $window,
             localStorageService, ngDialog, dataBaseColor) {
              $scope.appVersion=localStorageService.get( 'appVersion' + appSettings.sistemaId );
              //      $scope.loginData = authService.getLocalData( 'loginData' + appSettings.sistemaId );

              // inicializar la plantilla AdminLTE
              _initAdminLTETemplate();


               /*Create menu*/




              //   console.log(dataVersion);



              // console.log(  "Ver.Sistema_Scope",$scope.appVersion,
              //               "Ver.Sistema_Const",dataVersion.data.VERSION,
              //             "Ver.Sistema_LocSt",localStorageService.get( 'appVersion' + appSettings.sistemaId));


              //verifica la version del sistema y la actualiza,
              //funciona con F5, deslogearser o que se cierre la ventana
              // (function(){
              //     if(dataVersion.data.VERSION!=$scope.appVersion){
              //     console.log("Actualiza Sistema de",$scope.appVersion,"a",dataVersion.data.VERSION);
              //     $scope.appVersion=dataVersion.data.VERSION;
              //     localStorageService.set( 'appVersion' + appSettings.sistemaId, dataVersion.data.VERSION);
              //     window.location.reload();
              //   }else{
              //     console.log("Sistema Actualizado");
              //   }
              // }());

              //aqui funcionaria en todo momemto pero se consumiiria le servicio de verion muchas
              //veces
             /* $scope.$on('$viewContentLoaded', function() {
                 if($scope.constantes.VERSION_SISTEMA!=$scope.appVersion){
                  console.log("Actualiza Sistema de",$scope.appVersion,"a",$scope.constantes.VERSION_SISTEMA);
                  $scope.appVersion=$scope.constantes.VERSION_SISTEMA;
                  localStorageService.set( 'appVersion' + appSettings.sistemaId, $scope.constantes.VERSION_SISTEMA);
                  window.location.reload();
                }else{
                  console.log("Sistema Actualizado");
                }
              });*/

              //permite cambio de colores

              $scope.baseColores = dataBaseColor.data;
              
              /*$scope.selectedBaseColor = function(item)
              {
                $scope.ID_BASE_COLOR = item.ID_BASE_COLOR;
                $scope.cargaEstadisticas(true);
              }*/

              $scope.obtenerBaseColor = function(base)
              {
                //return $scope.ID_BASE_COLOR;
                $scope.ID_BASE_COLOR = base;
              }

              $scope.obtenerBaseColor("1");

              $scope.viewCambiarColores = function()
              {
                $scope.dialogShowCambiarColores = ngDialog.open(
                {
                  template: 'app/colores.view.tpl.html',
                  showClose: true,
                  closeByEscape: true,
                  className: 'ngdialog-theme-flat-custom custom-width-popupderecho',
                  scope:$scope,
                  //width:'500px',
                  controller: ['$scope', '$state', function($scope,$state) 
                  {
                    $scope.selectedBaseColor = function(item)
                    {
                      if (item.ID_BASE_COLOR != $scope.ID_BASE_COLOR)
                      {
                        $scope.obtenerBaseColor(item.ID_BASE_COLOR);
                        if (document.getElementById("ServicioMediacion").className == "activea")
                        {
                          $state.reload('index.dashboard.list');
                        }
                        else if (document.getElementById("ServicioFacilitacion").className == "activea")
                        {
                          $state.reload('index.facilitadores.list');
                        }
                        else
                        {
                          $state.reload('index.home');
                        }
                        toastr.success('Asignación cromática asignada exitosamente');
                        ngDialog.closeAll();
                      }
                    }
                  }]
                });  
              }

              //cambio de pestaña activa
              $scope.enfoqueServicios = function(opcion)
              {
                switch(opcion) 
                {
                  case 1:
                    //General
                    document.getElementById("ServiciosDireccion").className = "activea";
                    document.getElementById("ServicioMediacion").className = "";
                    document.getElementById("ServicioFacilitacion").className = "";
                    break;
                  case 2:
                    //Mediación
                    document.getElementById("ServiciosDireccion").className = "";
                    document.getElementById("ServicioMediacion").className = "activea";
                    document.getElementById("ServicioFacilitacion").className = "";
                    break;
                  case 3:
                    //Facilitación
                    document.getElementById("ServiciosDireccion").className = "";
                    document.getElementById("ServicioMediacion").className = "";
                    document.getElementById("ServicioFacilitacion").className = "activea";
                    break;
                }
              }
              $scope.enfoqueServicios(1);

              initialDate = new Date();
              $scope.aniossistema = "";
              if (initialDate.getFullYear() > 2019)
              {
                $scope.aniossistema = "2019-"+initialDate.getFullYear()+".";
              }

              $scope.TextClick = function ($event) {
                       $event.target.select();
              };

              console.log("window.location.hash",window.location.hash);
              localHash = window.location.hash;
              esdirectorio = false;

              var fechaActual = new Date();
              var anio = fechaActual.getFullYear();
              var mes = fechaActual.getMonth();
              var dia = fechaActual.getDate();
              var fechaMaximaValida = new Date(anio, mes, dia)
              var fechaMinimaValidaDashboardFJ = new Date(2014, 0, 1);
              var fechaMaximaValidaDashboard = new Date(anio, mes, dia);
              var fechaMinimaValida = "03/01/2019";

              // dateOptions
              $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 0,
                format: 'dd/MM/yyyy',
                formatDateTime: 'dd/MM/yyyy HH:mm',
                showMeridian: false
              };


              // dateOptions
              $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 0,
                format: 'dd/MM/yyyy',
                formatDateTime: 'dd/MM/yyyy HH:mm',
                showMeridian: false
              };

              $scope.dateOptionsDashboard = {
                autoclose: true,
                datepickerMode: 'day',
                formatYear: 'yyyy',
                startingDay: 0,
                format: 'dd/MM/yyyy',
                formatDateTime: 'dd/MM/yyyy HH:mm',
                showMeridian: false,
                maxDate:new Date(fechaMaximaValida),
                minDate:new Date(fechaMinimaValida),
                initDate: new Date(fechaMaximaValida)
              };

              $scope.dateOptionsDashboardFJ = {
                autoclose: true,
                datepickerMode: 'day',
                formatYear: 'yyyy',
                startingDay: 0,
                format: 'dd/MM/yyyy',
                formatDateTime: 'dd/MM/yyyy HH:mm',
                showMeridian: false,
                maxDate:new Date(fechaMaximaValidaDashboard),
                minDate:new Date(fechaMinimaValidaDashboardFJ),
                initDate: new Date(fechaMaximaValidaDashboard)
              };

              // objeto fechas que contiene todas las fechas de los forms
              $scope.openedDates = {};

              // funcion que muestra el datepicker
              $scope.openDate = function($event, field) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.openedDates[field] = true;
              };

              $scope.smartTable = appSettings.smartTable;

              // grid
              $scope.gridOptions = {
                enableRowSelection: true,
                multiSelect: true,
                enableSelectAll: true,
                enableRowSelection: true,
                enableRowHeaderSelection: false,
                selectionRowHeaderWidth: 35,
                groupingRowHeaderWidth: 50,
                paginationPageSizes: appSettings.paginationPageSizes,
                data: []
              };

              $scope.gridOptionsAGTThin = {
                enableRowSelection: true,
                multiSelect: false,
                enableSelectAll: false,
                enableRowSelection: true,
                enableRowHeaderSelection: false,
                //selectionRowHeaderWidth: 35,
                //groupingRowHeaderWidth: 50,
                paginationPageSizes: [5, 10, 50],
                data: []
              };

              $scope.gridOptionsAGTLarge = {
                enableRowSelection: true,
                multiSelect: false,
                enableSelectAll: false,
                enableRowSelection: true,
                enableFiltering: true,
                enableRowHeaderSelection: false,
                //selectionRowHeaderWidth: 35,
                //groupingRowHeaderWidth: 50,
                paginationPageSizes: [10, 25, 50],
                data: []
              };

              $scope.gridOptionsAGTDashboard = {
                enableRowSelection: true,
                multiSelect: false,
                enableSelectAll: false,
                enableRowSelection: true,
                enableFiltering: true,
                enableRowHeaderSelection: false,
                //selectionRowHeaderWidth: 35,
                //groupingRowHeaderWidth: 50,
                paginationPageSizes: [13, 25, 50],
                data: []
              };

              $scope.gridOptionsAGTReport = {
                enableRowSelection: true,
                multiSelect: false,
                enableSelectAll: false,
                enableRowSelection: true,
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableGridMenu: true,
                //selectionRowHeaderWidth: 35,
                //groupingRowHeaderWidth: 50,
                paginationPageSizes: [15, 25, 50],
                data: []
              };

              $scope.gridOptionsAGTComplex = {
                enableRowSelection: true,
                multiSelect: false,
                enableSelectAll: false,
                enableRowSelection: true,
                enableRowHeaderSelection: false,
                enableFiltering: true,
                //selectionRowHeaderWidth: 35,
                //groupingRowHeaderWidth: 50,
                paginationPageSizes: [15, 25, 100],
                data: []
              };

              $scope.gridOptionsSelection = {
                enableRowSelection: true,
                multiSelect:false,
                enableSelectAll: false,
                enableRowHeaderSelection: false,
                paginationPageSizes: appSettings.paginationPageSizes,
                data: []
              };

              //Charts
               $scope.chartOptionsNormal = {
                  legend: {
                      display: false
                  }
                };

              $scope.chartOptionsLegend = {
                  legend: {
                      display: true
                  }
                };

                $scope.chartOptionsLegendBar={
                  legend: {
                            display: false
                        },
                  animation: {
                      duration: 500,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x, model.y - 5);
                              }
                          });
                      }
                      /*easing: "easeOutQuart",
                      onComplete: function () {
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontFamily, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';

                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model,
                                      scale_max = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._yScale.maxHeight;
                                  ctx.fillStyle = '#444';
                                  var y_pos = model.y - 5;
                                  // Make sure data value does not get overflown and hidden
                                  // when the bar's value is too close to max value of scale
                                  // Note: The y value is reverse, it counts from top down
                                  if ((scale_max - model.y) / scale_max >= 0.93)
                                      y_pos = model.y + 20;
                                  ctx.fillText(dataset.data[i], model.x, y_pos);
                              }
                          });
                      }*/
                  }
                };


                //se incorporan otras opciones para graficas

                $scope.chartOptionsBarVertical={
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    //mode: null
                    onHover: function(e) {
                    var point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = 'pointer';
                    else e.target.style.cursor = 'default';
                    }
                  },
                  scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },

                layout: {
                  padding: {
                      left: 0,
                      right: 0,
                      top: 20,
                      bottom: 10
                  }
              },
                  animation: {
                      duration: 1000,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x, model.y - 1);
                              }
                          });
                      }
                  }
                };
                
                $scope.chartOptionsBarVerticalSinPointer={
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    mode: null
                    //mouse:'pointer'
                  },
                  /*hover: {
                    //mode: null
                    onHover: function(e) {
                    var point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = 'pointer';
                    else e.target.style.cursor = 'default';
                    }
                  },*/
                  scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },

                layout: {
                  padding: {
                      left: 0,
                      right: 0,
                      top: 20,
                      bottom: 10
                  }
              },
                  animation: {
                      duration: 500,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x, model.y - 1);
                              }
                          });
                      }
                  }
                };

                $scope.chartOptionsLine={
                  scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    yAxes: [{
                      ticks: {
                          beginAtZero: true
                      }
                  }]
                    },

                  layout: {
                    padding: {
                        left: 0,
                        right: 00,
                        top: 20,
                        bottom: 10
                    }
                  },
                  animation: {
                      duration: 500,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x + 8, model.y - 3);
                              }
                          });
                      }
                  },
                  elements: {
                    line: {
                        fill: false
                    }
                  }
                };

                $scope.chartOptionsLegendDetail = { 
                          legend: {
                            display: true,
                            labels: {
                                generateLabels: function(chart) {
                                    var data = chart.data;
                                    if (data.labels.length && data.datasets.length) {
                                        return data.labels.map(function(label, i) {
                                            var meta = chart.getDatasetMeta(0);
                                            var ds = data.datasets[0];
                                            var arc = meta.data[i];
                                            var custom = arc && arc.custom || {};
                                            var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                            var arcOpts = chart.options.elements.arc;
                                            var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                            var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                            var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                              // We get the value of the current label
                              var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                                            return {
                                                // Instead of `text: label,`
                                                // We add the value to the string
                                                text: label + "(" + value+")",
                                                fillStyle: fill,
                                                strokeStyle: stroke,
                                                lineWidth: bw,
                                                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                                index: i
                                            };
                                        });
                                    } else {
                                        return [];
                                    }
                                }
                            }
                        }
                };              

                $scope.chartOptionsDonutPie = {
                  layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 10,
                        bottom: 0
                    }
                  },
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    onHover: function(e) {
                      /*var point = this.getElementAtEvent(e);
                      if (point.length) e.target.style.cursor = 'pointer';
                      else*/ e.target.style.cursor = 'default';
                   },
                   mode: null
                  },
                  legend: {
                            display: true,
                            position:'bottom',
                            align: 'center',
                            labels:{
                              generateLabels: function(chart) {
                                var data = chart.data;
                                var total = 0;
                                
                                for (var d=0; d < chart.data.datasets[0].data.length; d++)
                                {
                                  total=total+parseInt(chart.data.datasets[0].data[d]);
                                }
                                
                                if (data.labels.length && data.datasets.length) {
                                    return data.labels.map(function(label, i) {
                                        var meta = chart.getDatasetMeta(0);
                                        var ds = data.datasets[0];
                                        var arc = meta.data[i];
                                        var custom = arc && arc.custom || {};
                                        var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                        var arcOpts = chart.options.elements.arc;
                                        var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                        var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                        var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                                        // We get the value of the current label
                                        var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];                                      
                                        var porcentaje = (value*100)/total;

                                        return {
                                            // Instead of `text: label,`
                                            // We add the value to the string
                                            text: label, //+ " " +porcentaje.toFixed(2)+"% (" + value+")",
                                            fillStyle: fill,
                                            strokeStyle: stroke,
                                            lineWidth: bw,
                                            hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                            index: i
                                        };
                                    });
                                } else {
                                    return [];
                                }
                            }
                            },
                            onHover: function(e) {
                              e.target.style.cursor = 'pointer';
                           }
                          },
                  pieceLabel: [
                    {
                      render: 'label',
                      render: function (args) {
                        return args.label +' ('+ args.value+')';
                      },
                      position: 'outside',
                      fontColor: '#000000'
                    },
                    {
                      render: 'percentage',
                      precision: 2,
                      fontColor: '#FFFFFF'
                    }
                  ]
                };

                $scope.chartOptionsPolarArea = {
                  layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 10,
                        bottom: 20
                    }
                  },
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    mode: null
                  },
                  legend: {
                        
                            display: true,
                            position:'right',
                            align: 'end',
                            labels:{
                              generateLabels: function(chart) {
                                var data = chart.data;
                                var total = 0;
                                
                                for (var d=0; d < chart.data.datasets[0].data.length; d++)
                                {
                                  total=total+parseInt(chart.data.datasets[0].data[d]);
                                }

                                if (data.labels.length && data.datasets.length) {
                                    return data.labels.map(function(label, i) {
                                        var meta = chart.getDatasetMeta(0);
                                        var ds = data.datasets[0];
                                        var arc = meta.data[i];
                                        var custom = arc && arc.custom || {};
                                        var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                        var arcOpts = chart.options.elements.arc;
                                        var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                        var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                        var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                                        // We get the value of the current label
                                        var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];                                      
                                        var porcentaje = (value*100)/total;

                                        return {
                                            // Instead of `text: label,`
                                            // We add the value to the string
                                            text: label + " " +porcentaje.toFixed(2)+"% (" + value+")",
                                            fillStyle: fill,
                                            strokeStyle: stroke,
                                            lineWidth: bw,
                                            hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                            index: i
                                        };
                                    });
                                } else {
                                    return [];
                                }
                            }
                            }
                          },
                  pieceLabel: [
                    {
                      //render: 'label',
                      render: function (args) {
                        return args.label +' ('+ args.value+')';
                      },
                      position: 'outside',
                      //arc: true,
                      fontColor: '#000000'
                    },
                    {
                      render: function (args) {
                        var total = 0;
                                
                        for (var d=0; d < args.dataset.data.length; d++)
                        {
                          total=total+parseInt(args.dataset.data[d]);
                        }

                        return ((args.value*100)/total).toFixed(2)+"%";
                      },
                      //position: 'outside',
                      //render: 'porcentaje',
                      //precision: 2,
                      fontColor: '#FFFFFF'
                    }

                    /*
                    {
                      render: 'label',
                      render: function (args) {
                        return args.label +' ('+ args.value+')';
                      },
                      position: 'outside',
                      fontColor: '#000000'
                    },
                    {
                      render: 'percentage',
                      precision: 2,
                      fontColor: '#FFFFFF'
                    }
                    */
                  ]
                };

                //se incorporan otras opciones para graficas


                $scope.chartOptionsLegendBarSimple={
                  legend: {
                            display: false
                        },
                  animation: {
                      duration: 500,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'center';
                          ctx.textBaseline = 'bottom';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x, model.y - 5);
                              }
                          });
                      }
                  }
                }

               /*$scope.chartOptionsLegendDetail = {
                          legend: {
                            display: true,
                            labels: {
                                generateLabels: function(chart) {
                                    var data = chart.data;
                                    if (data.labels.length && data.datasets.length) {
                                        return data.labels.map(function(label, i) {
                                            var meta = chart.getDatasetMeta(0);
                                            var ds = data.datasets[0];
                                            var arc = meta.data[i];
                                            var custom = arc && arc.custom || {};
                                            var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                            var arcOpts = chart.options.elements.arc;
                                            var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                            var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                            var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                              // We get the value of the current label
                              var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                                            return {
                                                // Instead of `text: label,`
                                                // We add the value to the string
                                                text: label + "(" + value+")",
                                                fillStyle: fill,
                                                strokeStyle: stroke,
                                                lineWidth: bw,
                                                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                                index: i
                                            };
                                        });
                                    } else {
                                        return [];
                                    }
                                }
                            }
                        }
                };*/

                $scope.chartOptionsLegendBarSimpleH={
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    //mode: null
                    onHover: function(e) {
                    var point = this.getElementAtEvent(e);
                    if (point.length) e.target.style.cursor = 'pointer';
                    else e.target.style.cursor = 'default';
                    }
                  },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },

                    layout: {
                      padding: {
                          left: 0,
                          right: 20,
                          top: 10,
                          bottom: 10
                      }
                  },

                  legend: {
                            display: false
                        },
                  animation: {
                      duration: 1000,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'left';
                          ctx.textBaseline = 'middle';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x + 1, model.y);
                              }
                          });
                      }
                  }
                };

                $scope.chartOptionsLegendBarSimpleHSinPointer={
                  tooltips: {
                    enabled: false
                  },
                  hover: {
                    mode: null
                    //mouse:'pointer'
                  },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },

                    layout: {
                      padding: {
                          left: 0,
                          right: 20,
                          top: 10,
                          bottom: 10
                      }
                  },

                  legend: {
                            display: false
                        },
                  animation: {
                      duration: 500,
                      onComplete: function () {
                          // render the value of the chart above the bar
                          var ctx = this.chart.ctx;
                          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                          ctx.fillStyle = this.chart.config.options.defaultFontColor;
                          ctx.textAlign = 'left';
                          ctx.textBaseline = 'middle';
                          this.data.datasets.forEach(function (dataset) {
                              for (var i = 0; i < dataset.data.length; i++) {
                                  var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                                  ctx.fillText(dataset.data[i], model.x + 1, model.y);
                              }
                          });
                      }
                  }
                };

              $scope.goTab = function(event) {
                event.preventDefault();
              };

              $scope.typeof = function(value, type) {
                return typeof value === type
              };

             /* $scope.logout = function(isValid) {
                authService.logOut();
                $state.go('login');
              };*/
            }]

        })
        .state("index.home", {

          url: "",

          views: {
            '': {
              templateUrl: 'app/home/home.tpl.html',
              resolve: {

              },
              controller: ['$scope', 'toastr', 'parametrizacionService', 'dashboardService', '$document',
                function (  $scope,   toastr, parametrizacionService, dashboardService, $document) {
                 // $state.go('index.resguardo.add');

                 //var num=(Math.floor((Math.random() * 2) + 1));
                 //$scope.bg='img/bg_home_'+num+'.jpg';

                  $scope.mostrarfechas = false;
  
                  $scope.tipoVistas=[{ID_TIPO_VISTA:1,TIPO_VISTA:'Distribución',ENFOQUE:false,MOSTRAR:true},{ID_TIPO_VISTA:2,TIPO_VISTA:'Directorio',ENFOQUE:true,MOSTRAR:true}];
  
                  $scope.rangoEstadisticas = {};
                  $scope.rangoEstadisticas.ID_BASE_COLOR = $scope.ID_BASE_COLOR;
                  $scope.rangoEstadisticas.ID_REGION = "0";
                  $scope.rangoEstadisticas.ID_DEPARTAMENTO = "0";
                  $scope.rangoEstadisticas.ID_TIPO_VISTA = 2;
                  $scope.rangoEstadisticas.SELECCION_EXTERNA_V1 = true;
                  $scope.rangoEstadisticas.SELECCION_EXTERNA_V2 = false;
                  
                  $scope.deshabilitartabla = false;
                  
                  //initialDate = new Date()
                  //para desplegar fecha inicial con un mes de anterioridad
                  /*temp = new Date(initialDate)
                  lastDayOfMonth = new Date(initialDate.getFullYear(), initialDate.getMonth(), 0);
                  day = '' + lastDayOfMonth.getDate();
                  ant= day * 86399.9 //dias en segundos
                  finalDate = new Date(temp.setSeconds(ant*-1))*/
  
                  finalDate = new Date();
                  finalDate.setFullYear( finalDate.getFullYear() - 1 ); //cambiar a -1, para que se cargue solo información del año anterior

                  $scope.rangoEstadisticas.FECHA = finalDate;
                  $scope.rangoEstadisticas.FECHA_FIN = new Date();
  
                  //configuracion de los tiempos en el desplazamiento de elementos
                  duration = 1000;
                  offset = 20;
                  $scope.scrollToElement = function(element)
                  {
                    elemento = angular.element(document.getElementById(element));
                    $document.scrollToElement(elemento, offset, duration);
                  }
  
                  $scope.enfocarTabla = function(item,externo)
                  {
                    switch (item.ID_TIPO_VISTA) {
                      case 1:
                      $scope.tipoVistas[1].ENFOQUE = false;
                      $scope.tipoVistas[0].ENFOQUE = true;
                      $scope.rangoEstadisticas.ID_TIPO_VISTA = item.ID_TIPO_VISTA;
                      if (externo)
                      {
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V1 = true;
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V2 = false;
                      }
                      break;
                    case 2:
                      $scope.tipoVistas[0].ENFOQUE = false;
                      $scope.tipoVistas[1].ENFOQUE = true;
                      $scope.rangoEstadisticas.ID_TIPO_VISTA = item.ID_TIPO_VISTA;
                      if (externo)
                      {
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V1 = false;
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V2 = true; 
                      }
                      break;
                    }
                  }
  
                  $scope.zingMapCoberturaMediacion = {
                    gui: {
                      contextMenu: {
                        visible:false
                        
                      }
                    },
                  globals: {
                    shadow:true
                  },
                  "background-color":"#FFF",
                  shapes: [
                    {
                      type: 'zingchart.maps',
                      options: {
                        name: 'gtm',
                        scrolling: true,
                        zooming: true,
                        style: {
                          label: {
                            visible:true
                          },
                          controls: {
                            visible: false
                          },
                          "background-color":"#F1F5F8",
                          "border-color":"#FFF",
                          "borderWidth": '1px',
                          hoverState: {
                            alpha: 0.3,
                            backgroundColor: '#FFF',
                            borderWidth: '3px'
                          }
                        }
                      }
                    }
                    ]
                  };
  
                  $scope.zingMapCoberturaFacilitadores = {
                    gui: {
                      contextMenu: {
                        visible:false
                        
                      }
                    },
                  globals: {
                    shadow:true
                  },
                  "background-color":"#FFF",
                  shapes: [
                    {
                      type: 'zingchart.maps',
                      options: {
                        name: 'gtm',
                        scrolling: true,
                        zooming: true,
                        style: {
                          label: {
                            visible:true
                          },
                          controls: {
                            visible: false
                          },
                          "background-color":"#F1F5F8",
                          "border-color":"#FFF",
                          "borderWidth": '1px',
                          hoverState: {
                            alpha: 0.3,
                            backgroundColor: '#FFF',
                            borderWidth: '3px'
                          }
                        }
                      }
                    }
                    ]
                  };
  
                  $scope.zingMapCoberturaMediacionRender = {
                    output : "canvas",
                    events : {
                      shape_click : function(p) 
                      {  
                        recarga_mapa = true;
                        for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                        {
                          if ($scope.dataDepartamentos[i].DEPARTAMENTO_ISO === p.shape.id) 
                          {
                            if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedRegion($scope.dataDepartamentos[i],0);
                            }
                            else if (($scope.rangoEstadisticas.ID_REGION == $scope.dataDepartamentos[i].ID_REGION) &&
                                      ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedDepartamento($scope.dataDepartamentos[i],0);
                            }
                            break;
                          }
                        }
                        if ((recarga_mapa) && (p.shape.id !== "BLZ"))
                        {
                          if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],0);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],0);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            $scope.selectedRegion($scope.dataDepartamentos[0],0);
                          }
                        }
                      }
                    }
                  };
  
                  $scope.zingMapCoberturaFacilitadoresRender = {
                    output : "canvas",
                    events : {
                      shape_click : function(p) 
                      {  
                        recarga_mapa = true;
                        for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                        {
                          if ($scope.dataDepartamentos[i].DEPARTAMENTO_ISO === p.shape.id) 
                          {
                            if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedRegion($scope.dataDepartamentos[i],0);
                            }
                            else if (($scope.rangoEstadisticas.ID_REGION == $scope.dataDepartamentos[i].ID_REGION) &&
                                      ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                            {
                              recarga_mapa = false;
                              $scope.selectedDepartamento($scope.dataDepartamentos[i],0);
                            }
                            break;
                          }
                        }
                        if ((recarga_mapa) && (p.shape.id !== "BLZ"))
                        {
                          if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],0);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                          {
                            $scope.selectedDepartamento($scope.dataDepartamentos[0],0);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            $scope.selectedRegion($scope.dataDepartamentos[0],0);
                          }
                        }
                      }
                    }
                  };
  
                  getRandomNumber = function(min, max){
                    min = Math.ceil(min)
                    max = Math.floor(max)
                    return Math.floor(Math.random() * (max - min)) + min;
                  }
  
                  cargaMenuDatosInicialesFacilitadoresMediacion = function(fecha,fechaFin,externo)
                  {
                    dashboardService.getFacilitadoresMediacion("menu"
                                                          ,0
                                                          ,0
                                                          ,fecha
                                                          ,fechaFin).then( function ( response ) {
                      $scope.servicios=response.data.data;

                      /*activosFJ = 0;
                      implementadoFJ = 0;
                      for (i=0;i < response.data.dataFJ.length;i++)
                      {
                        if (response.data.dataFJ[i].ID == "IMPLEMENTADO")
                        {
                          implementadoFJ = response.data.dataFJ[i].VALOR;
                        }
                        else if (response.data.dataFJ[i].ID == "ACTIVOS")
                        {
                          activosFJ = response.data.dataFJ[i].VALOR;
                        }
                      }*/
  
                      if ((response.data.dataFJ != []) || (response.data.dataFJ != undefined))
                      {
                        for (i=0;i < $scope.servicios.length;i++)
                        {
                          if ($scope.servicios[i].ID == "FJ")
                          {
                            if (response.data.dataFJ[0].SERVICIO_IMPLEMENTADO==response.data.dataFJ[0].SERVICIO_ACTIVO)
                            {
                              $scope.servicios[i].VALOR = '('+response.data.dataFJ[0].SERVICIO_IMPLEMENTADO+')';
                            }
                            else
                            {
                              $scope.servicios[i].VALOR = '('+response.data.dataFJ[0].SERVICIO_ACTIVO+') ['+response.data.dataFJ[0].SERVICIO_IMPLEMENTADO+']';
                              $scope.servicios[i].TOOLTIP = $scope.servicios[i].TOOLTIP2;
                            }
                          }
                        }
                      }

                      esdirectorio = false;
                      if (!externo)
                      {
                        if (localHash == '#/#dirmed')
                        {
                          $scope.enfocarPestana(1);
                          $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[0].TITULO_MAPA;
                          $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[0].TITULO_TABLA;
                          $scope.rangoEstadisticas.ID = $scope.servicios[0].ID;
                          esdirectorio = true;
                        }
                        else if (localHash == '#/#dirfj')
                        {
                          $scope.enfocarPestana(2);
                          $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[1].TITULO_MAPA;
                          $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[1].TITULO_TABLA;
                          $scope.rangoEstadisticas.ID = $scope.servicios[1].ID;
                          esdirectorio = true;
                        }
                        else 
                        {
                          activoRandom = getRandomNumber(0,11);
                          if (activoRandom <= 5)
                          {
                            $scope.enfocarPestana(1);
                            $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[0].TITULO_MAPA;
                            $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[0].TITULO_TABLA;
                            $scope.rangoEstadisticas.ID = $scope.servicios[0].ID;
                          }
                          else
                          {
                            $scope.enfocarPestana(2);
                            $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[1].TITULO_MAPA;
                            $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[1].TITULO_TABLA;
                            $scope.rangoEstadisticas.ID = $scope.servicios[1].ID;
                          }
                        }
                      }
                      else if (externo)
                      {
                        $scope.enfocarPestana(2);
                        $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[1].TITULO_MAPA;
                        $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[1].TITULO_TABLA;
                        $scope.rangoEstadisticas.ID = $scope.servicios[1].ID;
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
  
                  cargaEstadisticasCoberturaServicioMediacion = function()
                  {
                    dashboardService.getCoberturaMediacion($scope.rangoEstadisticas.ID+"mapaDMZ"
                                                          ,$scope.rangoEstadisticas.ID_REGION
                                                          ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                          ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                                                            
                    $scope.zingMapCoberturaMediacion.shapes[0].options.style.items=response.data.mapa;
                    $scope.mapaServicios = [];
                    $scope.mapaServicios = response.data.isodepto;
                    $scope.tablaservicios = [];
                    $scope.tablaservicios=response.data.tabla;
                    $scope.tablaserviciosdetallada = [];
                    $scope.tablaserviciosdetallada=response.data.tablaDetallada;

                    console.log("$scope.tablaserviciosdetallada",$scope.tablaserviciosdetallada);

                    if (($scope.rangoEstadisticas.ID_BASE_COLOR == 2) || ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                    {
                      if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                      {
                        //regiones
                        for (i=0;i < $scope.tablaservicios.length;i++)
                        {
                          $scope.tablaservicios[i].COLOR = "white";
                        }
                        //departamentos
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                      }
                      else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                      {
                        //regiones
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaservicios.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaservicios[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaservicios[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                        //departamentos
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                      }
                      else if (($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                      {
                        //departamentos
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                      }
                      /*else if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 2))
                      {
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                      }*/
                      else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 2))
                      {
                        //regiones
                        for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaservicios.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaservicios[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaservicios[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }
                        //departamentos
                        /*for (i=0;i < $scope.mapaServicios.length;i++)
                        {
                          for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                          {
                            if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                            {
                              $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                            }
                          }
                        }*/
                      }
                    }
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
  
                  cargaEstadisticasCoberturaServicioFacilitadores = function(fecha,fechaFin)
                    {
                      dashboardService.getCoberturaFacilitadores($scope.rangoEstadisticas.ID+"mapaDMZ"
                                                            ,$scope.rangoEstadisticas.ID_REGION
                                                            ,$scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO
                                                            ,fecha
                                                            ,fechaFin
                                                            ,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
  
                      $scope.zingMapCoberturaFacilitadores.shapes[0].options.style.items=response.data.mapa;
                      $scope.mapaServicios = [];
                      $scope.mapaServicios = response.data.isodepto;
                      $scope.tablaservicios = [];
                      $scope.tablaservicios=response.data.tabla;
                      $scope.tablaserviciosdetallada = [];
                      $scope.tablaserviciosdetallada=response.data.tablaDetallada;

                      if (($scope.rangoEstadisticas.ID_BASE_COLOR == 2) || ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                      {
                        if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                        {
                          //regiones
                          for (i=0;i < $scope.tablaservicios.length;i++)
                          {
                            $scope.tablaservicios[i].COLOR = "white";
                          }
                          //departamentos
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                        }
                        else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                        {
                          //regiones
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaservicios.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaservicios[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaservicios[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                          //departamentos
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                        }
                        else if (($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 3))
                        {
                          //departamentos
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                        }
                        /*else if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 2))
                        {
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                        }*/
                        else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0) && ($scope.rangoEstadisticas.ID_BASE_COLOR == 2))
                        {
                          //regiones
                          for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaservicios.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaservicios[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaservicios[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }
                          //departamentos
                          /*for (i=0;i < $scope.mapaServicios.length;i++)
                          {
                            for (j=0;j < $scope.tablaserviciosdetallada.length;j++)
                            {
                              if ($scope.mapaServicios[i].id_iso_depto == $scope.tablaserviciosdetallada[j].ID_DEPARTAMENTO_ISO)
                              {
                                $scope.tablaserviciosdetallada[j].COLOR = $scope.mapaServicios[i].color;
                              }
                            }
                          }*/
                        }
                      }
                      
                      }, function ( error ) {
                        toastr.error( error );
                      });
                      
                    }
  
                  $scope.cargaEstadisticas=function(isValid,opcion,externo){
                    var fecha = moment($scope.rangoEstadisticas.FECHA).format("DD-MM-YYYY");
                    var fechaFin = moment($scope.rangoEstadisticas.FECHA_FIN).format("DD-MM-YYYY");
                    //serán para facilitadores únicamente
                    //fechaTituloFechas($scope.rangoEstadisticas.FECHA,$scope.rangoEstadisticas.FECHA_FIN);
                      if ( isValid) {
                        switch (opcion) {
                          case 0:
                            cargaMenuDatosInicialesFacilitadoresMediacion(fecha,fechaFin,false);
                            break;
                          case 1:
                            $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[0].TITULO_MAPA;
                            $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[0].TITULO_TABLA;
                            $scope.rangoEstadisticas.ID = $scope.servicios[0].ID;
                            cargaEstadisticasCoberturaServicioMediacion(fecha,fechaFin);
                            break;
                          case 2:
                            $scope.rangoEstadisticas.TITULO_MAPA = $scope.servicios[1].TITULO_MAPA;
                            $scope.rangoEstadisticas.TITULO_TABLA = $scope.servicios[1].TITULO_TABLA;
                            $scope.rangoEstadisticas.ID = $scope.servicios[1].ID;
                            if (externo)
                            {
                              cargaMenuDatosInicialesFacilitadoresMediacion(fecha,fechaFin,true);
                            }
                            cargaEstadisticasCoberturaServicioFacilitadores(fecha,fechaFin);
                              break;
                          } 
                      }
                    }
  
                  $scope.selectedDepartamentoFacilitadores = function (item,seccion)
                  {
                    for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                    {
                      if ($scope.dataDepartamentos[i].ID_DEPARTAMENTO_ISO === item.ID_DEPARTAMENTO_ISO) 
                      {
                        $scope.selectedDepartamento($scope.dataDepartamentos[i],0); 
                        break;
                      }
                    }
                  }
  
                  $scope.selectedDepartamento = function (item,seccion)
                  {
                    $scope.rangoEstadisticas.ID_DEPARTAMENTO = item.ID_DEPARTAMENTO;
                    $scope.rangoEstadisticas.ID_DEPARTAMENTO_ISO = item.ID_DEPARTAMENTO_ISO;
                    if (seccion==1)
                    {
                      $scope.rangoEstadisticas.DEPARTAMENTO = item.NOMBRE_DEPARTAMENTO;  
                    }
                    else
                    {
                      $scope.rangoEstadisticas.DEPARTAMENTO = item.DEPARTAMENTO;
                    }
                    $scope.rangoEstadisticas.ID_REGION_DEPARTAMENTO = item.ID_REGION;
  
                    if (item.ID_DEPARTAMENTO > 0)
                    {
                      $scope.enfocarTabla($scope.tipoVistas[1],false);
                      $scope.deshabilitartabla = true;
                    }
                    else
                    {
                      $scope.deshabilitartabla = false;
                      if (esdirectorio)
                      {
                        $scope.enfocarTabla($scope.tipoVistas[1],true);
                        esdirectorio = false;
                      }
                      else if ($scope.rangoEstadisticas.SELECCION_EXTERNA_V1)
                      {
                        $scope.enfocarTabla($scope.tipoVistas[0],false);
                      }
                      else
                      {
                        $scope.enfocarTabla($scope.tipoVistas[1],false);
                      }
                    }
                    
                    if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO == 0))
                    {
                      $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación"; 
                      $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                    }
                    else if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO > 0))
                    {
                      $scope.tooltip_mapa = "Para volver a todos los departamentos de la región, haga clic en un departamento no filtrado";
                      $scope.tooltip_mapaB="";
                    }
                    else if (item.ID_DEPARTAMENTO > 0 )
                    {
                      $scope.tooltip_mapa="";
                      $scope.tooltip_mapaB = "";
                    }
                    $scope.cargaEstadisticas(true,$scope.pestanaActiva);
                    
                  }
  
                  //se cargan los departamentos
                  cargaDepartamentos = function(pestanaActiva,region)
                  {
                    $scope.dataDepartamentos = [];
                    switch (pestanaActiva)
                    {
                      case 1:
                        parametrizacionService.getDeptoMunicipioCentros(region,1,7).then( function ( response ) {
                          $scope.dataDepartamentos=response.data;
                          $scope.selectedDepartamento($scope.dataDepartamentos[0]);
                        }, function ( error ) {
                          toastr.error( error );
                        });
                      break;
                      case 2:
                        parametrizacionService.getDeptoMunicipioCentros(region,1,5).then( function ( response ) {
                          $scope.dataDepartamentos=response.data;
                          $scope.selectedDepartamento($scope.dataDepartamentos[0]);
                        }, function ( error ) {
                          toastr.error( error );
                        });
                      break;
                    }
                  }
  
                  $scope.selectedRegion = function (item)
                  {
                    $scope.rangoEstadisticas.ID_REGION = item.ID_REGION;
                    $scope.rangoEstadisticas.REGION = item.REGION;
                    if (item.ID_REGION == 0)
                    {
                      $scope.tooltip_mapa = "Para filtrar una región, haga clic en un departamento";
                      $scope.tooltip_mapaB = "";
                    }
                    else if (item.ID_REGION > 0)
                    {
                      $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación";
                      $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                    }
                    cargaDepartamentos($scope.pestanaActiva,item.ID_REGION);
                  }
  
                  //se cargan las regiones
                  $scope.cargaRegionesDepartamentosExterno = function(opcion)
                  {
                    switch (opcion)
                    {
                      case 1:
                        cargaRegiones($scope.pestanaActiva);
                      break;
                      case 2:
                        cargaDepartamentos($scope.pestanaActiva,$scope.rangoEstadisticas.ID_REGION);
                        $scope.enfocarTabla($scope.tipoVistas[0],false);
                        $scope.deshabilitartabla = false;
                      break;
                      case 11:
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V1 = true;
                        $scope.rangoEstadisticas.SELECCION_EXTERNA_V2 = false;
                        $scope.enfocarTabla($scope.tipoVistas[0],false);
                        $scope.deshabilitartabla = false;
                      break;
                    }
                  }
  
                  cargaRegiones = function(pestanaActiva)
                  {
                    $scope.dataRegiones = [];
                    switch (pestanaActiva)
                    {
                      case 1:
                        parametrizacionService.getDeptoMunicipioCentros(0,0,6).then( function ( response ) {
                          $scope.dataRegiones=response.data;
                          $scope.selectedRegion($scope.dataRegiones[0]);
                        }, function ( error ) {
                          toastr.error( error );
                        });
                      break;
                      case 2:
                        parametrizacionService.getDeptoMunicipioCentros(0,0,4).then( function ( response ) {
                          $scope.dataRegiones=response.data;
                          $scope.selectedRegion($scope.dataRegiones[0]);
                        }, function ( error ) {
                          toastr.error( error );
                        });
                      break;
                    }
                  }
  
                  $scope.enfocarPestana = function(id,externo)
                  {
                    $scope.enfocarTabla($scope.tipoVistas[0],false);
                    $scope.deshabilitartabla = false;
                    $scope.menumediacion = false;               
                    $scope.menufacilitadores = false;
                    $scope.mostrarfechas = false;
                    $scope.pestanaActiva = id;
                    $scope.rangoEstadisticas.SELECCION_EXTERNA_V1 = true;
                    $scope.rangoEstadisticas.SELECCION_EXTERNA_V2 = false;
                    switch (id)
                    {
                      case 1:
                        //mediacion
                        $scope.menumediacion = true; 
                        cargaRegiones($scope.pestanaActiva);
                      break;
                      case 2:
                        //facilitadores
                        $scope.menufacilitadores = true;
                        $scope.mostrarfechas = true;
                        cargaRegiones($scope.pestanaActiva);
                      break;
                    }
  
                  }                
  
                  $scope.cargaEstadisticas(true,0,0);


              }]
            },
            /*'hint@index': {
              template: '<h1>Posts</h1>'
            }*/
          }

        })

    }
  ]
)

.constant( 'appSettings', appSettings);
